import { useQuery } from '@apollo/client'
import { AuthContext } from '@deltek/specification-client/core/Configurations/AuthContext'
import { FirmResellerStatusQuery } from 'bpm/api/graphQL/queries/firm.queries'
import { FirmResponse } from 'bpm/api/graphQL/types/firm.types'
import { isUserBPMAdmin } from 'bpm/pages/ProductsPage/productsUtils'
import { useContext } from 'react'

export const useIsBPMReseller = (): boolean => {
    const currentUserInfoResponse = useContext(AuthContext)
    const { currentUserInfo } = currentUserInfoResponse
    const accountId = currentUserInfo?.account?.accountId ?? ''
    const isBPM = !!isUserBPMAdmin(currentUserInfoResponse).isBPM

    const { data } = useQuery<FirmResponse>(FirmResellerStatusQuery, {
        variables: { id: accountId },
        skip: !accountId || !isBPM,
    })

    return data?.firm?.isReseller ?? false
}
